export default (value) => ({
  welcome_mail: 'Mail de Bienvenida',
  invoice_reception_mail: 'Notificación de facturas recibidas',
  invoice_rejection_mail: 'Notificación de rechazo',
  saas_rejection_mail: 'Notificación de rechazo con invitación',
  email_confirmation: 'Confirmación de correo',
  confirming_supplier_letter: 'Mail de confirming',
}[value] || value);
